import { isAuthenticated } from '../utils/authHelper';
import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar';
import Delete from '@material-ui/icons/Delete'
import Info from '@material-ui/icons/Visibility'
import Edit from '@material-ui/icons/Edit'
import TextField from '@material-ui/core/TextField'
import Table from './SelectTable'
import Header from './Header'
import { browserHistory } from 'react-router'
import { businessUnitMap, statusMap } from '../constants/paymentStatus';
import Button from '@material-ui/core/Button'
import token from '../config/jwt_token'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogBox from './Dialogbox'
import CSVGenerator from '../utils/json2csv'
import PaymentInitAuth from './PaymentInitAuth'
import _ from 'lodash';
import {
  generateOtp, getPendingPayments, getProcessedPayments,
  getApprovingPayments, deletePendingPayment, intializePayments,
  forgetPassword,
  validateGSTN,
  // fetchBuList,
  changeProcessedPaymentStatus
} from '../utils/PaymentRequestApiUtils'
import { faintBlack } from 'material-ui/styles/colors';
import { billTypeList } from '../constants/billTypeList';
import { formatDate } from '../utils/globalUtils';
import { Tabs, Tab } from '@material-ui/core';
import moment from 'moment';

const keys = require('../config/keys');
const constants = require('../config/constants');
class PaymentProcess extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      data: [],
      filteredData : [],
      columns: [],
      previewData: {},
      showDialogBox: false,
      currentIndex: null,
      currentEntity: 'pending',
      snackOpen: false,
      showAuth: false,
      secretKey: '',
      hasSecreKeyError: false,
      secretKeyErrorText: '',
      open: false,
      otpDialogbox: false,
      buList: businessUnitMap || {},
      tableState: {
        selectedData: [],
        selection: [],
        selectAll: false
      },
      pageIndex: 0,
      disablePaymentInitBtn: true,
      blockedPaymentDialogBox: false,
      blockedPaymentDialogBoxText: '',
      fromDateShow: '',
      toDateShow: '',
      fromDateErr: false,
      fromDateErrText: '',
      toDateErr: false,
      toDateErrText: '',
      inProgress: false,
      confirmHoldDialogOpen: false,
      selectedPaymentRequestIds: {
        pr_ids: [],
        pr_transaction_log_ids: []
      },
      showHoldData: false,
      holdData: [],
      holdComment : '',
      unholdComment : ''
    }
    this.tablePageChangehandler = this.tablePageChangehandler.bind(this)
    this.selectedData = [];
    this.bufData = []
    this.handleDateChange = this.handleDateChange.bind(this);
    this.submitFilter = this.submitFilter.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
  }
  async componentDidMount() {
    // let buList = [];
    // // fetchData().then(response => {
    // //   this.setState({
    // //     data: response.data,
    // //     filteredData: response.data
    // //   });
    // // })
    // try {
    //   const response = await fetchBuList();
    //   if (response.status === 'success') {
    //     buList = response.data;
    //     this.setState({ buList })
    //   }
    // } catch (error) {
    //   console.log(error)
    // }

    if (this.props.location.state) {
      this.setState({ pageIndex: this.props.location.state.pageIndex })
    }
    let entity = this.props.params.entity
    if (!token || (token.role === 'City Finance' && entity === 'approve')) {
      browserHistory.push('/')
      return
    }
    let response
    switch (entity) {
      case 'pending': {
        this.setState({ currentEntity: 'pending' })
        response = await getPendingPayments(JSON.stringify({}))
        break
      }
      case 'approved': {
        this.setState({ currentEntity: 'approved' })
        response = await getProcessedPayments(JSON.stringify({}))
        break
      }
      case 'approve': {
        this.setState({ currentEntity: 'approve' })
        response = await getApprovingPayments(JSON.stringify({}))
        break
      }
      case 'success': {
        this.setState({ currentEntity: 'success' })
        response = { status: 'success' }
        break;
      }
      case 'failure': {
        this.setState({ currentEntity: 'failure' })
        response = { status: 'success' }
        break
      }
    }

    if (response) {
      if (response.status === 'success') {
        let { data, columns, holdData } = this.state
        if (entity === 'approved') {
          columns = [{
            key: 'payment_request_id',
            Header: 'PR Index'
          },
          {
            key: 'bs_Id',
            Header: 'Bill Submission Id'
          },
          {
            key: 'bs_requesterEmail',
            Header: 'Bill Submission Requester'
          },
          {
            key: 'payment_id', // actually payment_request_code
            Header: 'Payment Code'
          },
          {
            key: 'vendor_name',
            Header: 'Vendor Name'
          },
          {
            key: 'ledger_name',
            Header: 'Ledger Name'
          },
          {
            key: 'date_of_invoice',
            Header: 'Date of Invoice'
          },
          {
            key: 'invoice_number',
            Header: 'Invoice Number'
          },
          {
            key: 'advance_paid',
            Header: 'Advance Paid'
          },
          {
            key: 'supporting_document_link',
            Header: 'Supporting Document'
          },
          {
            key: 'mode_of_payment',
            Header: 'Payment Mode'
          },
          {
            key: 'narration',
            Header: 'Narration'
          },
          {
            key: 'no_of_cost_centers',
            Header: 'Cost Centers'
          },
          {
            key: 'city',
            Header: 'City'
          },
          {
            key: 'business_unit',
            Header: 'Business Unit'
          },
          {
            key: 'total_invoice_amount',
            Header: 'Taxable Amount'
          },
          {
            key: 'total_payable_amount',
            Header: 'Net Payable'
          },
          {
            key: 'full_invoice_amount_display',
            Header: 'Total PO Amount'
          },
          {
            key: 'total_deduction',
            Header: 'All Deductions'
          },
          {
            key: 'requester_name',
            Header: 'Requester Name'
          },
          {
            key: 'approverl1_name',
            Header: 'Approver L1 Name'
          },
          {
            key: 'approverl2_name',
            Header: 'Approver L2 Name'
          },
          {
            key: 'raised_on',
            Header: 'Raised On'
          },
          {
            key: 'status',
            Header: 'Status'
          },
          {
            key : 'invoice_due_date',
            Header: 'Invoice Due Date'
          },
          {
            key: 'accounting_status',
            Header: 'Accounting Status'
          },
          {
            key: 'accounting_status_by',
            Header: 'Accounting Status By'
          },
          {
            key: 'accounting_status_date',
            Header: 'Accounting Status Date'
          },
          {
            key : 'hold_comment',
            Header: 'Hold Comment'
          },
          {
            key : 'unhold_comment',
            Header: 'Unhold Comment'
          },
          {
            key : 'hold_unhold_by',
            Header: 'Hold/Unhold By'
          },
          {
            key : 'hold_unhold_date',
            Header: 'Hold/Unhold Date'
          },
          {
            key: 'action',
            Header: 'Action'
          }]
        } else {
          columns = [{
            key: 'action',
            Header: 'Action'
          },
          {
            key: 'payment_request_id',
            Header: 'PR Index'
          },
          {
            key: 'bs_Id',
            Header: 'Bill Submission Id'
          },
          {
            key: 'bs_requesterEmail',
            Header: 'Bill Submission Requester'
          },
          {
            key: 'bill_type',
            Header: 'Bill Type'
          },
          {
            key: 'business_unit',
            Header: 'Business Unit'
          },
          {
            key: 'vendor_name',
            Header: 'Vendor Name'
          },
          {
            key: 'payment_id', // actually payment_request_code
            Header: 'Payment Code'
          },
          {
            key: 'ledger_name',
            Header: 'Ledger Name'
          },
          {
            key: 'date_of_invoice',
            Header: 'Date of Invoice'
          },
          {
            key: 'expenditure_start_date',
            Header: 'Expenditure Start Date'
          },
          {
            key: 'expenditure_end_date',
            Header: 'Expenditure End Date'
          },
          {
            key: 'advance_paid',
            Header: 'Advance Paid'
          },
          {
            key: 'invoice_number',
            Header: 'Invoice Number'
          },
          {
            key: 'supporting_document_link',
            Header: 'Supporting Document'
          },
          {
            key: 'mode_of_payment',
            Header: 'Payment Mode'
          },
          {
            key: 'narration',
            Header: 'Narration'
          },
          {
            key: 'no_of_cost_centers',
            Header: 'Cost Centers'
          },
          {
            key: 'city',
            Header: 'City'
          },
          {
            key: 'total_invoice_amount',
            Header: 'Taxable Amount'
          },
          {
            key: 'total_payable_amount',
            Header: 'Net Payable'
          },
          {
            key: 'full_invoice_amount_display',
            Header: 'Total PO Amount'
          },
          {
            key: 'total_deduction',
            Header: 'All Deductions'
          },
          {
            key: 'requester_name',
            Header: 'Requester Name'
          },
          {
            key: 'raised_on',
            Header: 'Raised On'
          },
          {
            key: 'status',
            Header: 'Status'
          },
          {
            key : 'invoice_due_date',
            Header: 'Invoice Due Date'
          }]
        }

        let ch_columns = [
          {
            key: 'action',
            Header: 'Action'
          },
          {
            key: 'payment_request_id',
            Header: 'PR Index'
          },
          {
            key: 'bs_Id',
            Header: 'Bill Submission Id'
          },
          {
            key: 'bs_requesterEmail',
            Header: 'Bill Submission Requester'
          },
          {
            key: 'bill_type',
            Header: 'Bill Type'
          },
          {
            key: 'business_unit',
            Header: 'Business Unit'
          },
          {
            key: 'vendor_name',
            Header: 'Vendor Name'
          },
          {
            key: 'advance_paid',
            Header: 'Advance Paid'
          },
          {
            key: 'invoice_number',
            Header: 'Invoice Number'
          },
          {
            key: 'supporting_document_link',
            Header: 'Supporting Document'
          },
          {
            key: 'total_payable_amount',
            Header: 'Net Payable'
          },
          {
            key: 'full_invoice_amount_display',
            Header: 'Total PO Amount'
          },
          {
            key: 'no_of_cost_centers',
            Header: 'Cost Centers'
          },
          {
            key: 'narration',
            Header: 'Narration'
          },
          {
            key: 'city',
            Header: 'City'
          },
          {
            key: 'ledger_name',
            Header: 'Ledger Name'
          },
          {
            key: 'date_of_invoice',
            Header: 'Date of Invoice'
          },
          {
            key: 'total_invoice_amount',
            Header: 'Taxable Amount'
          },
          {
            key: 'total_deduction',
            Header: 'All Deductions'
          },
          {
            key: 'requester_name',
            Header: 'Requester Name'
          },
          {
            key: 'raised_on',
            Header: 'Raised On'
          },
          {
            key: 'status',
            Header: 'Status'
          },
          {
            key : 'invoice_due_date',
            Header: 'Invoice Due Date'
          },
          {
            key: 'payment_id', // actually payment_request_code
            Header: 'Payment Code'
          },
          {
            key: 'mode_of_payment',
            Header: 'Payment Mode'
          }]

        switch (entity) {
          case 'pending': {
            this.setState({ currentEntity: 'pending' })
            data = response.data.map((cur) => ({
              payment_request_id: cur.payment_request_id,
              bs_Id: cur.bill_submission_data ? cur.bill_submission_data.bs_Id : '',
              bs_requesterEmail: cur.bill_submission_data ? cur.bill_submission_data.bs_requesterEmail : '',
              payment_request_transaction_log_id: cur.payment_request_transaction_log_id,
              bill_type: billTypeList.find(billType => billType.value === cur.payment_request.bill_type) && billTypeList.find(billType => billType.value === cur.payment_request.bill_type).label,
              expenditure_start_date: cur.payment_request.expenditure_start_date,
              expenditure_end_date: cur.payment_request.expenditure_end_date,
              business_unit: (this.state.buList[cur.payment_request.business_unit] && this.state.buList[cur.payment_request.business_unit].value) || cur.payment_request.business_unit || '',
              payment_id: cur.payment_request.payment_request_code || 'NA',
              vendor_name: cur.payment_request.vendor_name,
              vendor_code: cur.payment_request.vendor_code,
              invoice_due_date: cur.payment_request.invoice_due_date ? formatDate(cur.payment_request.invoice_due_date) : cur.payment_request.invoice_due_date,
              ledger_name: cur.payment_request.cost_center_entries[0].gst_splits[0].ledger_name,
              date_of_invoice: cur.payment_request.date_of_invoice,
              advance_paid: cur.payment_request.advance_paid,
              invoice_number: ((cur.payment_request.type_of_payment === 'Final Settlement') && (cur.payment_request.invoice_soft_copy_link !== '')) ? <a href={cur.payment_request.invoice_soft_copy_link} target="_blank">{cur.payment_request.invoice_number}</a> : cur.payment_request.invoice_number,
              invoice_soft_copy_link: cur.payment_request.invoice_soft_copy_link,
              supporting_document_link: this.renderSdLinks(cur.payment_request.supporting_document_link),
              mode_of_payment: cur.payment_request.mode_of_payment,
              narration: cur.payment_request.narration,
              no_of_cost_centers: cur.payment_request.cost_center_entries.length === 1 ? cur.payment_request.cost_center_entries[0].center_details.LOCALNAME : 'Multi Cost centers',
              city: cur.payment_request.cost_center_entries[0].center_details.CITY,
              total_payable_amount: cur.payment_request.total_payable_amount,
              full_invoice_amount_display: (cur.payment_request.partial_payment_percentage && cur.payment_request.full_invoice_amount) ? cur.payment_request.full_invoice_amount : '-',
              total_invoice_amount: cur.payment_request.total_invoice_amount,
              initial_invoice_amount: cur.payment_request.initial_invoice_amount,
              total_deduction: cur.payment_request.total_discount + cur.payment_request.total_deduction_others
                + cur.payment_request.total_tds_deduction,
              requester_name: cur.requester_name,
              status: cur.transaction_status,
              all_data: cur,
              raised_on: cur.payment_request.created_at.split('T')[0],
              action: (token.role === 'City Finance' || token.role === 'root') ?
                <div>
                  <Info style={{ cursor: 'pointer' }} onClick={this.showInfo.bind(this, cur.payment_request_id)} />
                  <Edit style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.showEdit.bind(this, cur.payment_request_id)} />
                  <Delete style={{ marginLeft: '20px', cursor: 'pointer' }} onClick={this.alertDialog.bind(this, cur.payment_request_id)} />

                </div> :
                <div>
                  <Info onClick={this.showInfo.bind(this, cur.payment_request_id)} />
                </div>
            }))
            break
          }
          case 'approved': {
            this.setState({ currentEntity: 'approved' })
            const tempData = response.data.map((cur) => ({
              payment_request_id: cur.payment_request_id,
              bs_Id: cur.bill_submission_data ? cur.bill_submission_data.bs_Id : '',
              bs_requesterEmail: cur.bill_submission_data ? cur.bill_submission_data.bs_requesterEmail : '',
              payment_request_transaction_log_id: cur.payment_request_transaction_log_id,
              payment_id: cur.payment_request.payment_request_code,
              vendor_name: cur.payment_request.vendor_name,
              vendor_code: cur.payment_request.vendor_code,
              invoice_due_date: cur.payment_request.invoice_due_date ? formatDate(cur.payment_request.invoice_due_date) : cur.payment_request.invoice_due_date,
              ledger_name: cur.payment_request.cost_center_entries[0].gst_splits[0].ledger_name,
              date_of_invoice: cur.payment_request.date_of_invoice,
              advance_paid: cur.payment_request.advance_paid,
              invoice_number: ((cur.payment_request.type_of_payment === 'Final Settlement') && (cur.payment_request.invoice_soft_copy_link !== '')) ? <a href={cur.payment_request.invoice_soft_copy_link} target="_blank">{cur.payment_request.invoice_number}</a> : cur.payment_request.invoice_number,
              invoice_soft_copy_link: cur.payment_request.invoice_soft_copy_link,
              bill_type: (billTypeList.find(bt => bt.value === cur.payment_request.bill_type) || {}).label || cur.payment_request.bill_type || '',
              supporting_document_link: this.renderSdLinks(cur.payment_request.supporting_document_link),
              mode_of_payment: cur.payment_request.mode_of_payment,
              narration: cur.payment_request.narration,
              no_of_cost_centers: cur.payment_request.cost_center_entries.length === 1 ? cur.payment_request.cost_center_entries[0].center_details.LOCALNAME : 'Multi Cost centers',
              city: cur.payment_request.cost_center_entries[0].center_details.CITY,
              business_unit: (this.state.buList[cur.payment_request.business_unit] && this.state.buList[cur.payment_request.business_unit].value) || cur.payment_request.business_unit || '',
              total_invoice_amount: cur.payment_request.total_invoice_amount,
              total_deduction: cur.payment_request.total_discount + cur.payment_request.total_deduction_others
                + cur.payment_request.total_tds_deduction,
              total_payable_amount: cur.payment_request.total_payable_amount,
              full_invoice_amount_display: (cur.payment_request.partial_payment_percentage && cur.payment_request.full_invoice_amount) ? cur.payment_request.full_invoice_amount : '-',
              requester_name: cur.requester_name,
              status: cur.transaction_status,
              all_data: cur,
              raised_on: cur.payment_request.created_at.split('T')[0],
              approverl1_name: cur.approverl1_name,
              approverl2_name: cur.approverl2_name,
              accounting_status: cur.accounting_status === 'accounted' ? 'Accounted' : 'Unaccounted',
              accounting_status_by: cur.accounting_status_by,
              accounting_status_date: cur.accounting_status_date ? moment(cur.accounting_status_date).format('YYYY-MM-DD hh:mm A') : '',
              hold_comment: cur.hold_comment,
              unhold_comment: cur.unhold_comment,
              hold_unhold_by: cur.hold_unhold_by,
              hold_unhold_date: cur.hold_unhold_date ? moment(cur.hold_unhold_date).format('YYYY-MM-DD hh:mm A') : '',
              action: <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
                <Info style={{ cursor: 'pointer' }} onClick={this.showInfo.bind(this, cur.payment_request_id)} />
                {(token.role === 'Super Central Finance' || token.role === 'root' || token.role === 'Payment Hold Operator') && <Button variant="contained" size="small" color="primary" onClick={this.openConfirmHoldDialog.bind(this, cur.payment_request_id, cur.payment_request_transaction_log_id)}>
                  {cur.transaction_status === 'hold_at_processed' ? 'Unhold' : 'Hold'}
                </Button>}
              </div>
            }))
            data = tempData.filter(cur => cur.status !== 'hold_at_processed')
            holdData = tempData.filter(cur => cur.status === 'hold_at_processed')
            break
          }
          case 'approve': {
            this.setState({ currentEntity: 'approve' })
            data = response.data.map((cur) => ({
              payment_request_id: cur.payment_request_id,
              bs_Id: cur.bill_submission_data ? cur.bill_submission_data.bs_Id : '',
              bs_requesterEmail: cur.bill_submission_data ? cur.bill_submission_data.bs_requesterEmail : '',
              payment_request_transaction_log_id: cur.payment_request_transaction_log_id,
              payment_id: cur.payment_request.payment_request_code || 'NA',
              vendor_name: cur.payment_request.vendor_name,
              vendor_code: cur.payment_request.vendor_code,
              invoice_due_date: cur.payment_request.invoice_due_date ? formatDate(cur.payment_request.invoice_due_date) : cur.payment_request.invoice_due_date,
              date_of_invoice: cur.payment_request.date_of_invoice,
              advance_paid: cur.payment_request.advance_paid,
              invoice_number: ((cur.payment_request.type_of_payment === 'Final Settlement') && (cur.payment_request.invoice_soft_copy_link !== '')) ? <a href={cur.payment_request.invoice_soft_copy_link} target="_blank">{cur.payment_request.invoice_number}</a> : cur.payment_request.invoice_number,
              invoice_soft_copy_link: cur.payment_request.invoice_soft_copy_link,
              supporting_document_link: this.renderSdLinks(cur.payment_request.supporting_document_link),
              ledger_name: cur.payment_request.cost_center_entries[0].gst_splits[0].ledger_name,
              bill_type: billTypeList.find(billType => billType.value === cur.payment_request.bill_type) && billTypeList.find(billType => billType.value === cur.payment_request.bill_type).label,
              business_unit: (this.state.buList[cur.payment_request.business_unit] && this.state.buList[cur.payment_request.business_unit].value) || cur.payment_request.business_unit || '',
              expenditure_start_date: cur.payment_request.expenditure_start_date,
              expenditure_end_date: cur.payment_request.expenditure_end_date,
              mode_of_payment: cur.payment_request.mode_of_payment,
              narration: cur.payment_request.narration,
              no_of_cost_centers: cur.payment_request.cost_center_entries.length === 1 ? cur.payment_request.cost_center_entries[0].center_details.LOCALNAME : 'Multi Cost centers',
              city: cur.payment_request.cost_center_entries[0].center_details.CITY,
              total_invoice_amount: cur.payment_request.total_invoice_amount,
              total_deduction: cur.payment_request.total_discount + cur.payment_request.total_deduction_others
                + cur.payment_request.total_tds_deduction,
              total_payable_amount: cur.payment_request.total_payable_amount,
              full_invoice_amount_display: (cur.payment_request.partial_payment_percentage && cur.payment_request.full_invoice_amount) ? cur.payment_request.full_invoice_amount : '-',
              requester_name: cur.requester_name,
              status: cur.transaction_status,
              all_data: cur,
              raised_on: cur.payment_request.created_at.split('T')[0],
              action: <Info style={{ cursor: 'pointer' }} onClick={this.showInfo.bind(this, cur.payment_request_id)} />
            }))
            break
          }
          case 'success': {
            this.setState({ currentEntity: 'success' })
            break;
          }
          case 'failure': {
            this.setState({ currentEntity: 'failure' })
            break;
          }
          default: break
        }
        data = data.map(rowData => {
          rowData.status = statusMap[rowData.status].value
          return rowData
        })
        holdData = holdData.map(rowData => {
          rowData.status = statusMap[rowData.status].value
          return rowData
        })
        this.setState({ data: data, columns: columns, filteredData: data, holdData: holdData })
        if (token.role === 'City Head') {
          this.setState({ columns: ch_columns })
        }
      }
      else {
        this.setState({ snackMessage: response.message, snackOpen: true })
      }
    }

  }
  alertDialog(pr_id) {
    const index = this.state.data.findIndex(item => item.payment_request_id === pr_id);
    this.setState({ showDialogBox: true, currentIndex: index })
  }
  async deletePaymentRequest() {
    let { data } = this.state
    let id = data[this.state.currentIndex].payment_request_transaction_log_id
    deletePendingPayment(JSON.stringify({ payment_request_transaction_log_id: id })).then(res => {
      if (res.status === 'success') {
        data.splice(this.state.currentIndex, 1)
        this.setState({ data: data, showDialogBox: false, snackMessage: res.message, snackOpen: true })
      }
      else {
        this.setState({ snackMessage: res.message, snackOpen: true, showDialogBox: false })
      }

    })
  }
  handleCloseblockedPaymentDialogBox() {
    // As of now this case is only possible with approved vendors.
    this.setState({ blockedPaymentDialogBox: false, blockedPaymentDialogBoxText: `` })
  }
  // Renders supporting_document_link as clickable links — handles JSON arrays (new-zaps) and plain URLs (legacy)
  renderSdLinks(sdLink) {
    if (!sdLink) return '';
    try {
      const docs = JSON.parse(sdLink);
      if (Array.isArray(docs) && docs.length > 0) {
        return docs.map((url, i) => (
          <span key={i}>
            {i > 0 && ', '}
            <a href={url} target="_blank" rel="noopener noreferrer">Att {i + 1}</a>
          </span>
        ));
      }
    } catch (e) {}
    return <a href={sdLink} target="_blank" rel="noopener noreferrer">{sdLink}</a>;
  }
  showEdit(pr_id) {
    const index = this.state.data.findIndex(item => item.payment_request_id === pr_id);
    if (index === -1 || this.state.data[index].all_data.transaction_status === 'blocked') {
      this.setState({
        blockedPaymentDialogBox: true, blockedPaymentDialogBoxText: `This payment is blocked due to incorrect bank details (Vendor). 
      Kindly update vendor details to raise payment request against them` })
      return
    }

    const S3_BASE = 'https://erp-modules-zolo-production.s3.amazonaws.com/';
    const toFullUrl = (key) => {
      if (!key || key === '' || key === 'null') return null;
      if (key.startsWith('http')) return key;
      return S3_BASE + key;
    };

    // Resolve supporting_document_link: JSON array of S3 keys OR plain key/URL
    const rawSdLink = this.state.data[index].all_data.payment_request.supporting_document_link;
    let resolvedSdLink = rawSdLink;
    if (rawSdLink) {
      try {
        const parsed = JSON.parse(rawSdLink);
        if (Array.isArray(parsed) && parsed.length > 0) {
          // Keep as JSON array string but with full URLs
          resolvedSdLink = JSON.stringify(parsed.map(toFullUrl).filter(Boolean));
        }
      } catch (e) {
        resolvedSdLink = toFullUrl(rawSdLink) || rawSdLink;
      }
    }

    let payment_request = {
      ...this.state.data[index].all_data.payment_request,
      invoice_soft_copy_link: toFullUrl(this.state.data[index].all_data.payment_request.invoice_soft_copy_link) || '',
      supporting_document_link: resolvedSdLink || '',
      payment_request_transaction_log_id: this.state.data[index].all_data.payment_request_transaction_log_id,
      centralFinanceComments: this.state.data[index].all_data.central_finance_remarks,
      cityHeadComments: this.state.data[index].all_data.city_head_remarks,
      payment_status: this.state.data[index].all_data.transaction_status,
      vendor_ldc_data: this.state.data[index].all_data.payment_request.vendor_ldc_data ? JSON.parse(this.state.data[index].all_data.payment_request.vendor_ldc_data) : null,
      bs_Id: this.state.data[index].all_data.bill_submission_data ? this.state.data[index].all_data.bill_submission_data.bs_Id : '',
    }
    let cost_center_entries = this.state.data[index].all_data.payment_request.cost_center_entries.map(data => {
      data.entity_nameSearchText = `${data.center_details.LOCALNAME} (${data.center_details.Type}), ${data.center_details.CITY}`
      return data
    })
    delete payment_request.cost_center_entries;
    payment_request.prevPath = this.props.location.pathname;
    browserHistory.push({
      pathname: '/payment/request/edit',
      state: { 
        editData: { 
          payment_request: payment_request, 
          cost_center_entries: { 
            entries: cost_center_entries,
            defaultor_amount_deduction: payment_request.defaultor_amount_deduction
          } 
        } 
      }
    })
  }
  showInfo(pr_id) {
    const prData = this.state.data && this.state.data.length ? this.state.data.find(item => item.payment_request_id === pr_id) : []
    let data = { ...prData }
    let total_sgst_amount = data.all_data.payment_request.total_sgst_amount, total_cgst_amount = data.all_data.payment_request.total_cgst_amount,
      total_igst_amount = data.all_data.payment_request.total_igst_amount, total_ugst_amount = data.all_data.payment_request.total_ugst_amount,
      total_gst_amount = total_sgst_amount + total_cgst_amount + total_igst_amount + total_ugst_amount
    let renderedData = {
      total_invoice_amount: data.all_data.payment_request.total_invoice_amount,
      total_sgst_amount: total_sgst_amount,
      total_cgst_amount: total_cgst_amount,
      total_igst_amount: total_igst_amount,
      total_ugst_amount: total_ugst_amount,
      total_gst_amount: total_gst_amount,
      total_tds_deduction: data.all_data.payment_request.total_tds_deduction,
      total_deduction_others: data.all_data.payment_request.total_deduction_others,
      total_discount: data.all_data.payment_request.total_discount,
      advance_paid: data.all_data.payment_request.advance_paid,
      payment_request_transaction_log_id: data.all_data.payment_request_transaction_log_id,
      vendor_id: data.all_data.payment_request.vendor_id,
      vendor_code: data.all_data.payment_request.vendor_code,
      vendor_deactivate: data.all_data.payment_request.vendor_deactivate,
      agreement_expiry_date: data.all_data.payment_request.agreement_expiry_date,
      vendor_agreement_file_name: data.all_data.payment_request.vendor_agreement_file_name,
      total_payable_amount: data.all_data.payment_request.total_payable_amount,
      defaultor_amount: data.all_data.payment_request.defaultor_amount,
      pancard_status: data.all_data.payment_request.pancard_status,
      payment_request_id: data.all_data.payment_request.payment_request_id,
    }
    const S3_BASE = 'https://erp-modules-zolo-production.s3.amazonaws.com/';
    const toFullUrl = (key) => {
      if (!key || key === '' || key === 'null') return null;
      if (key.startsWith('http')) return key;
      return S3_BASE + key;
    };

    // supporting_document_link: may be a JSON array of S3 keys OR a plain S3 key/URL
    const rawSdLink = data.all_data.payment_request.supporting_document_link;
    let resolvedSdLink = null;
    if (rawSdLink) {
      try {
        const parsed = JSON.parse(rawSdLink);
        if (Array.isArray(parsed) && parsed.length > 0) {
          // Expand each S3 key to full URL and re-serialize
          resolvedSdLink = JSON.stringify(parsed.map(toFullUrl).filter(Boolean));
        }
      } catch (e) {
        // Plain key or URL
        resolvedSdLink = toFullUrl(rawSdLink);
      }
    }

    renderedData.paymentDetails = {
      type_of_payment: data.all_data.payment_request.type_of_payment,
      vendor_name: data.all_data.payment_request.vendor_name,
      vendor_code: data.all_data.payment_request.vendor_code,
      po_number: data.all_data.payment_request.po_number,
      invoice_number: data.all_data.payment_request.invoice_number,
      advance_paid: data.all_data.payment_request.advance_paid,
      invoice_soft_copy_link: toFullUrl(data.all_data.payment_request.invoice_soft_copy_link),
      supporting_document_link: resolvedSdLink,
      expenditure_month: data.all_data.payment_request.expenditure_month,
      date_of_invoice: data.all_data.payment_request.date_of_invoice,
      mode_of_payment: data.all_data.payment_request.mode_of_payment,
      narration: data.all_data.payment_request.narration,
      centralFinanceComments: data.all_data.central_finance_remarks,
      cityHeadComments: data.all_data.city_head_remarks,
      gstn_status: data.all_data.payment_request.gstn_status,
      payment_status: data.all_data.transaction_status,
      vendor_ldc_data: data.all_data.payment_request.vendor_ldc_data ? JSON.parse(data.all_data.payment_request.vendor_ldc_data) : null,
      business_unit: data.all_data.payment_request.business_unit,
      expenditure_start_date: data.all_data.payment_request.expenditure_start_date,
      expenditure_end_date: data.all_data.payment_request.expenditure_end_date,
    }
    let cost_center_entries = data.all_data.payment_request.cost_center_entries.map(data => {
      data.entity_nameSearchText = `${data.center_details.LOCALNAME} (${data.center_details.Type}), ${data.center_details.CITY}`
      return data
    })
    renderedData.cost_center_entries = {
      entries: cost_center_entries,
      is_recoverable: data.all_data.payment_request.is_recoverable === 0 ? false : true,
      amount_recoverable: data.all_data.payment_request.amount_recoverable,
      as_per_agreement: data.all_data.payment_request.as_per_agreement === 0 ? false : true,
      recoverable_amount_remarks: data.all_data.payment_request.recoverable_amount_remarks,
      gst_type: data.all_data.payment_request.gst_type,
      gst_avail_type: data.all_data.payment_request.gst_avail_type,
      defaultor_amount_deduction: data.all_data.payment_request.defaultor_amount_deduction
    }
    renderedData.bill_submission_data = data.all_data.bill_submission_data ? data.all_data.bill_submission_data : null; 
    renderedData.location = this.props.location.pathname
    // Need to pass these params for table page number retention
    renderedData.pageIndex = this.state.pageIndex
    renderedData.currentEntity = this.state.currentEntity
    browserHistory.push({
      pathname: `/vendor/payment/${this.state.currentEntity}/preview`,
      state: renderedData
    })
  }


  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  handleClose() {
    this.setState({ showDialogBox: false })
  }
  handleYes() {
    this.deletePaymentRequest()
  }
  handleNo() {
    this.setState({ showDialogBox: false })
  }
  updateSelected(selections, selectedData, selectAll = false) {
    // we need to enable the button and keep it enabled for selected > 0
    let selected;
    if (!selectedData.length) { selected = true }
    else { selected = false }
    this.selectedData = selectedData;
    this.setState({
      tableState: {
        selection: selections,
        selectedData: selectedData,
        selectAll: selectAll,
      },
      disablePaymentInitBtn: selected
    })
  }
  getCSVData = () => {
    let csvData = this.selectedData.length === 0 ? ((this.state.currentEntity === 'approved' && this.state.showHoldData) ? this.state.holdData : (this.state.currentEntity === 'approved' ? this.state.filteredData : this.state.data)) : this.selectedData
    let urlRegxp = constants.urlRegxp;
    let emptyRegxp = constants.emptyRegxp;
    let data = csvData.map((cur) => {
      const getBillTypeLabel = (billTypeValue) => {
        const foundBillType = billTypeList.find(billType => billType.value === billTypeValue);
        return foundBillType ? foundBillType.label : billTypeValue;
      }
      const billType = cur.all_data.payment_request.bill_type 
                          ? getBillTypeLabel(cur.all_data.payment_request.bill_type) 
                          : cur.all_data.payment_request.bill_type;
      const paymentData = {
        'PR Index': cur.all_data.payment_request.payment_request_id,
        'Bill Submission Id': cur.all_data.bill_submission_data ? cur.all_data.bill_submission_data.bs_Id : '',
        'Bill Submission Requester': cur.all_data.bill_submission_data ? cur.all_data.bill_submission_data.bs_requesterEmail : '',
        'Payment Code': cur.all_data.payment_request.payment_request_code,
        'Bill Type': billType,
        'Business Unit': (this.state.buList[cur.all_data.payment_request.business_unit] && this.state.buList[cur.all_data.payment_request.business_unit].value) || cur.all_data.payment_request.business_unit || '',
        'Vendor Name': cur.all_data.payment_request.vendor_name,
        'Date of Invoice': cur.all_data.payment_request.date_of_invoice,
        'Invoice Due Date': cur.invoice_due_date ? formatDate(cur.invoice_due_date) : cur.invoice_due_date,
        'Mode of Payment': cur.all_data.payment_request.mode_of_payment,
        'Type of Payment': cur.all_data.payment_request.type_of_payment,
        'PO Number': cur.all_data.payment_request.po_number,
        'Expenditure of Month': cur.all_data.payment_request.expenditure_month,
        'Expenditure Start Date': cur.all_data.payment_request.expenditure_start_date,
        'Expenditure End Date': cur.all_data.payment_request.expenditure_end_date,
        /*'TDS Liability': cur.all_data.payment_request.tds_liability,
        'IT Section Applicable': cur.all_data.payment_request.it_section_applicable,*/
        'Beneficiary Name': cur.all_data.payment_request.beneficiary_name,
        'City': cur.all_data.payment_request.cost_center_entries[0].center_details.CITY,
        'Bank Name': cur.all_data.payment_request.bank_name,
        'Invoice Number': cur.all_data.payment_request.invoice_number,
        'Advance Paid': cur.all_data.payment_request.advance_paid,
        'Supporting Document': urlRegxp.test(cur.all_data.payment_request.supporting_document_link) || emptyRegxp.test(cur.all_data.payment_request.supporting_document_link) || cur.all_data.payment_request.supporting_document_link === null ? cur.all_data.payment_request.supporting_document_link : keys.s3.fileLink + cur.all_data.payment_request.supporting_document_link,
        'Bill Availability': cur.all_data.payment_request.bill_availability,
        'Expenditure Category': cur.all_data.payment_request.cost_center_entries[0].gst_splits[0].ledger_name,
        'Narration': cur.all_data.payment_request.narration,
        'Cost Center': cur.all_data.payment_request.cost_center_entries.length === 1 ? cur.all_data.payment_request.cost_center_entries[0].center_details.LOCALNAME : 'Muliple Cost Centers',
        'Total Invoice Amount': cur.all_data.payment_request.total_invoice_amount,
        'Total SGST': cur.all_data.payment_request.total_sgst_amount,
        'Total CGST': cur.all_data.payment_request.total_cgst_amount,
        'Total IGST': cur.all_data.payment_request.total_igst_amount,
        'Total UGST': cur.all_data.payment_request.total_ugst_amount,
        'TDS Deductions': cur.all_data.payment_request.total_tds_deduction,
        'Deduction Other Than TDS': cur.all_data.payment_request.total_deduction_others,
        'Discount': cur.all_data.payment_request.total_discount,
        'Advance Paid': cur.all_data.payment_request.advance_paid,
        'Total Payable Amount': cur.all_data.payment_request.total_payable_amount,
        'Total PO Amount': (cur.all_data.payment_request.partial_payment_percentage && cur.all_data.payment_request.full_invoice_amount) ? cur.all_data.payment_request.full_invoice_amount : '-',
        'Recoverable Amount (as Per ZAPS)': cur.all_data.payment_request.amount_recoverable,
        'Recoverable Amount (as Per Bill Submission)': cur.all_data.payment_request.billSub_recoverable_amount,
        'Recoverability Remarks': cur.all_data.payment_request.recoverable_amount_remarks,
        'Attachment': urlRegxp.test(cur.all_data.payment_request.invoice_soft_copy_link) || emptyRegxp.test(cur.all_data.payment_request.invoice_soft_copy_link) || cur.all_data.payment_request.invoice_soft_copy_link === null ? cur.all_data.payment_request.invoice_soft_copy_link : keys.s3.fileLink + cur.all_data.payment_request.invoice_soft_copy_link,
        'Supporting Document': urlRegxp.test(cur.all_data.payment_request.supporting_document_link) || emptyRegxp.test(cur.all_data.payment_request.supporting_document_link) || cur.all_data.payment_request.supporting_document_link === null ? cur.all_data.payment_request.supporting_document_link : keys.s3.fileLink + cur.all_data.payment_request.supporting_document_link,
        'Requester Name': cur.all_data.requester_name,
        'L1 Approver Name': cur.all_data.approverl1_name,
        'L2 Approver Name': cur.all_data.approverl2_name,
        'Status': cur.status
      }
      if(this.state.currentEntity === 'approved') {
        paymentData['Accounting Status'] = cur.all_data.accounting_status === 'accounted' ? 'Accounted' : 'Unaccounted'
        paymentData['Accounting Status By'] = cur.all_data.accounting_status_by
        paymentData['Accounting Status Date'] = cur.all_data.accounting_status_date ? moment(cur.all_data.accounting_status_date).format('YYYY-MM-DD hh:mm A') : ''
        paymentData['Hold Comment'] = cur.hold_comment
        paymentData['Unhold Comment'] = cur.unhold_comment
        paymentData['Hold/Unhold By'] = cur.hold_unhold_by
        paymentData['Hold/Unhold Date'] = cur.hold_unhold_date ? moment(cur.hold_unhold_date).format('YYYY-MM-DD hh:mm A') : ''
      }
      return paymentData;
    })
    return {
      data: data,
      filename: this.state.currentEntity === 'approve' ? 'Approve-Payments-Request' : (this.state.showHoldData ? 'PaymentsOnHold' : 'PaymentInit')
    }
  }
  updateSecreKey(event) {
    this.setState({ secretKey: event.target.value, secretKeyErrorText: '', hasSecreKeyError: false })
  }
  async handleCancelPaymentInitAuth() {
    this.setState({ showAuth: false, secretKeyErrorText: '', hasSecreKeyError: false, secretKey: '' })
  }
  async handlePaymentInitAuth() {
    if (!this.state.secretKey) {
      this.setState({ secretKeyErrorText: 'This is a required field', hasSecreKeyError: true })
      return
    }
    this.setState({ showAuth: false })
    if (this.selectedData.length !== 0) {
      this.setState({ open: true })
      let data = this.selectedData.map(data => {
        return {
          payment_request_transaction_log_id: data.all_data.payment_request_transaction_log_id,
          total_payable_amount: data.all_data.payment_request.total_payable_amount,
          ifsc_code: data.all_data.payment_request.ifsc_code,
          beneficiary_account_number: data.all_data.payment_request.bank_acc_number,
          beneficiary_bank_name: data.all_data.payment_request.bank_name,
          beneficiary_email: data.all_data.payment_request.beneficiary_email,
          beneficiary_name: data.all_data.payment_request.beneficiary_name,
          debit_account_number: data.all_data.payment_request.debit_account_number,
          business_unit: data.all_data.payment_request.business_unit,
          cost_centers: data.all_data.payment_request.cost_center_entries.map(cost_center => {
            return {
              city: cost_center.center_details.CITY,
              entity_name: cost_center.center_details.LOCALNAME
            }
          })
        }

      })
      if (localStorage.getItem('payment_request') !== undefined && JSON.parse(localStorage.getItem('payment_request')) === data) {
        return;
      }
      else {
        localStorage.setItem('payment_request', JSON.stringify(data));
        intializePayments(JSON.stringify({ password: this.state.secretKey, payment_inits: data })).then(response => {
          if (response) {
            if (response.status === 'success') {
              if (response.data.length > 0) {
                response.data.map(file => {
                  var exportedFilename = file.filename + '.csv' || 'export.csv';
                  var blob = new Blob([file.content], { type: 'text/csv;charset=utf-8;' });
                  if (navigator.msSaveBlob) { // IE 10+
                    navigator.msSaveBlob(blob, exportedFilename);
                  } else {
                    var link = document.createElement("a");
                    if (link.download !== undefined) { // feature detection
                      // Browsers that support HTML5 download attribute
                      var url = URL.createObjectURL(blob);
                      link.setAttribute("href", url);
                      link.setAttribute("download", exportedFilename);
                      link.style.visibility = 'hidden';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }
                  }
                })
              }
              let resultantData = []
              for (let data of this.state.data) {
                let commonData = 0
                for (let selectedData of this.selectedData) {
                  if (data.payment_request_transaction_log_id === selectedData.payment_request_transaction_log_id)
                    commonData++
                }
                if (commonData === 0)
                  resultantData.push(data)
              }
              this.selectedData = []
              // disable the button once all the selected data are initialized
              this.setState({
                data: resultantData, open: false, tableState: { selectedData: [], selection: [], selectAll: false },
                disablePaymentInitBtn: true
              })
            }
            else {
              this.setState({ snackMessage: response.message, snackOpen: true, open: false, showAuth: true })
            }
          }

        })
      }
      this.setState({ secretKey: '' })
    }
    localStorage.removeItem('payment_request')
  }
  generateCSV() {
    let csvData = this.getCSVData()
    CSVGenerator(Object.keys(csvData.data[0]), csvData.data, csvData.filename)
  }

  generatePendingPaymentsCSV() {
    let csvData = this.getCSVData()
    CSVGenerator(Object.keys(csvData.data[0]), csvData.data, `${localStorage.getItem('selected_city')}-Pending Payments`)
  }

  async handleOk() {
    getApprovingPayments(JSON.stringify({})).then(response => {
      if (response) {
        if (response.status === 'success') {
          let data = response.data.map((cur, index) => ({
            payment_request_id: cur.payment_request_id,
            payment_request_transaction_log_id: cur.payment_request_transaction_log_id,
            payment_id: 'NA',
            vendor_name: cur.payment_request.vendor_name,
            vendor_code: cur.payment_request.vendor_code,
            date_of_invoice: cur.payment_request.date_of_invoice,
            invoice_due_date : cur.invoice_due_date ? formatDate(cur.invoice_due_date) : cur.invoice_due_date,
            invoice_number: ((cur.payment_request.type_of_payment === 'Final Settlement') && (cur.payment_request.invoice_soft_copy_link !== '')) ? <a href={cur.payment_request.invoice_soft_copy_link} target="_blank">{cur.payment_request.invoice_number}</a> : cur.payment_request.invoice_number,
            advance_paid: cur.payment_request.advance_paid,
            invoice_soft_copy_link: cur.payment_request.invoice_soft_copy_link,
            supporting_document_link: this.renderSdLinks(cur.payment_request.supporting_document_link),
            ledger_name: cur.payment_request.cost_center_entries[0].gst_splits[0].ledger_name,
            mode_of_payment: cur.payment_request.mode_of_payment,
            narration: cur.payment_request.narration,
            no_of_cost_centers: cur.payment_request.cost_center_entries.length === 1 ? cur.payment_request.cost_center_entries[0].center_details.LOCALNAME : 'Multi Cost centers',
            city: cur.payment_request.cost_center_entries[0].center_details.CITY,
            total_invoice_amount: cur.payment_request.total_invoice_amount,
            total_deduction: cur.payment_request.total_discount + cur.payment_request.total_deduction_others
              + cur.payment_request.total_tds_deduction,
            total_payable_amount: cur.payment_request.total_payable_amount,
            requester_name: cur.requester_name,
            status: statusMap[cur.transaction_status].value,
            all_data: cur,
            raised_on: cur.payment_request.created_at.split('T')[0],
            action: <Info style={{ cursor: 'pointer' }} onClick={this.showInfo.bind(this, cur.payment_request_id)} />
          }))
          //reset table state as well (total selected rows and total selected amounts are flushed)
          this.setState({
            data: data, tableState: {
              selectedData: [],
              selection: [],
              selectAll: false
            }
          })
        }
      }
    })
  }

  otpGeneration() {
    generateOtp(JSON.stringify({})).then(res => {
      if (res.status === 'success') {
        this.setState({ otpDialogbox: true })
      }
    })
  }
  handleChange(props, event, value) {
    this.setState({ [props]: event.target.value, [props + 'Err']: false, [props + 'ErrText']: '' })
  }
  handleSubmit() {
    if (!this.state.otp) {
      this.setState({ otpErr: true, otpErrText: 'This field is required' })
    }
    if (!this.state.confirm_password) {
      this.setState({ confirm_passwordErr: true, confirm_passwordErrText: 'This field is required' })
    }
    if (!this.state.password) {
      this.setState({ passwordErr: true, passwordErrText: 'This field is required' })
    }
    if (this.state.password !== this.state.confirm_password) {
      this.setState({ snackOpen: true, snackMessage: 'Password and Confirm password should be same' })
      return
    }
    if (this.state.otp && this.state.password && this.state.confirm_password) {
      forgetPassword(JSON.stringify({ password: this.state.password, otp: this.state.otp }))
        .then(res => {
          if (res.status === 'success') {
            this.setState({ otpDialogbox: false, snackOpen: true, snackMessage: res.message, password: '', otp: '', confirm_password: '' })
          }
          else {
            this.setState({ snackOpen: true, snackMessage: res.message, password: '', otp: '', confirm_password: '' })
          }
        })
    }
  }
  handleOtpNo() {
    this.setState({ otpDialogbox: false, otp: '', password: '', confirm_password: '' })
  }
  tablePageChangehandler(event) {
    this.setState({ pageIndex: event });
  }
  handleDateChange = (field) => (event) => {
    this.setState({ 
      [field]: event.target.value,
      [`${field}Err`]: false,
      [`${field}ErrText`]: '' 
    });
  }
  submitFilter() {
    let fromDate = new Date(this.state.fromDateShow);
    let toDate = new Date(this.state.toDateShow);
    if (fromDate > toDate) {
      this.setState({ snackOpen: true, snackMessage: 'From date should be less than To date' });
      return;
    }
    this.setState({ inProgress: true }, () => {
      const filteredData = this.state.data.filter(item => {
        const invoiceDueDate = item.invoice_due_date;
        return (
          (!this.state.fromDateShow || invoiceDueDate >= this.state.fromDateShow) &&
          (!this.state.toDateShow || invoiceDueDate <= this.state.toDateShow)
        );
      });

      this.setState({ 
        filteredData,
        inProgress: false 
      });
    });
  }
  clearFilter() {
    this.setState({ 
      fromDateShow: '', 
      toDateShow: '', 
      fromDateErr: false, 
      toDateErr: false, 
      fromDateErrText: '', 
      toDateErrText: '', 
      filteredData: this.state.data 
    });
  }
  async handleInitializePayment() {
    let showAuthModal = true;
    // validating whether the GST is suspended or cancelled
    for (let cur of this.state.tableState.selectedData) {
      const isGSTNValid = await validateGSTN(cur.vendor_code);
      if (isGSTNValid.flag && (isGSTNValid.data[0].gstn_status == "SUSPENDED" || isGSTNValid.data[0].gstn_status == "CANCELLED")) {
        this.setState({ snackOpen: true, snackMessage: `GSTN is ${isGSTNValid.data[0].gstn_status} for vendor ${cur.vendor_name}` });
        showAuthModal = false;
        break;
      }
    }
    this.setState({ showAuth: showAuthModal });
  }

  openConfirmHoldDialog(paymentRequestId, paymentRequestTransactionLogId) {
    this.setState((prevState) => ({
      confirmHoldDialogOpen: true,
      selectedPaymentRequestIds: {
        pr_ids: [...prevState.selectedPaymentRequestIds.pr_ids, paymentRequestId],
        pr_transaction_log_ids: [...prevState.selectedPaymentRequestIds.pr_transaction_log_ids, paymentRequestTransactionLogId]
      },
    }));
  }

  closeConfirmHoldDialog() {
    this.setState({ confirmHoldDialogOpen: false, selectedPaymentRequestIds: {
      pr_ids: [],
      pr_transaction_log_ids: []
    } });
  }

  async confirmHoldPayment() {
    const { selectedPaymentRequestIds, holdComment, unholdComment} = this.state;
    if (selectedPaymentRequestIds.pr_transaction_log_ids.length > 0) {
      try {
        const response = await changeProcessedPaymentStatus(JSON.stringify({ 
          payment_request_ids: selectedPaymentRequestIds.pr_ids, 
          payment_request_transaction_log_ids: selectedPaymentRequestIds.pr_transaction_log_ids, 
          status: 'hold',
          comment: {
            holdComment: holdComment,
            unholdComment: unholdComment
          }
        }));
        if (response.status === 'success') {
          this.setState({ snackMessage: response.message, snackOpen: true });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      } catch (error) {
        console.error("Error confirming hold payment:", error);
        this.setState({ snackMessage: 'Failed to hold payment. Please try again.', snackOpen: true });
      }
      this.closeConfirmHoldDialog();
    }
  }

  async confirmUnholdPayment() {
    const { selectedPaymentRequestIds, holdComment, unholdComment} = this.state;
    if (selectedPaymentRequestIds.pr_transaction_log_ids.length > 0) {
      try {
        const response = await changeProcessedPaymentStatus(JSON.stringify({ 
          payment_request_ids: selectedPaymentRequestIds.pr_ids, 
          payment_request_transaction_log_ids: selectedPaymentRequestIds.pr_transaction_log_ids, 
          status: 'unhold',
          comment: {
            holdComment: holdComment,
            unholdComment: unholdComment
          }
        }));
        if (response.status === 'success') {
          this.setState({ snackMessage: response.message, snackOpen: true });
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      } catch (error) {
        console.error("Error unholding payment:", error);
        this.setState({ snackMessage: 'Failed to unhold payment. Please try again.', snackOpen: true });
      }
      this.closeConfirmHoldDialog();
    }
  }

  handleTabChange(event, newValue) {
    this.setState({ showHoldData: newValue === 1, tableState: { selectedData: [], selection: [], selectAll: false } });
    this.clearFilter();
  }

  handleUnholdButtonClick() {
    if (this.state.tableState.selectedData.length > 0) {
      const selectedIds = this.state.tableState.selectedData.map(data => data.payment_request_id);
      const selectedPrIds = this.state.tableState.selectedData.map(data => data.payment_request_transaction_log_id);
      this.setState({
        confirmHoldDialogOpen: true,
        selectedPaymentRequestIds: {
          pr_ids: selectedIds,
          pr_transaction_log_ids: selectedPrIds
        },
      });
    } else {
      this.setState({ snackMessage: 'No payments selected for unholding.', snackOpen: true });
    }
  }

  render() {
    const entityTitles = {
      pending:  'Pending Payments',
      approve:  'Approve Payments',
      approved: 'Processed Payments',
      success:  'Payment Success',
      failure:  'Payment Failure',
    };
    const pageTitle = entityTitles[this.state.currentEntity] || 'Payments';

    return (
      <MuiThemeProvider>
        <Header />
        <div className="zaps-page-wrap">

          {/* Page header */}
          <div className="zaps-page-header">
            <h2 className="zaps-page-title">{pageTitle}</h2>
            {this.state.data.length > 0 && this.props.params.entity === 'pending' && (
              <Button variant="contained" size="medium" color="primary" onClick={this.generatePendingPaymentsCSV.bind(this)}>
                Download CSV
              </Button>
            )}
          </div>


        {this.state.currentEntity === 'approved' && (
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '16px' }}>
            <Tabs
              value={this.state.showHoldData ? 1 : 0}
              onChange={this.handleTabChange.bind(this)}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab label="Approved Payments" />
              <Tab label="Payments on Hold" />
            </Tabs>
            {!this.state.showHoldData && (
              <div className="zaps-filter-row">
                <span className="zaps-filter-label">Invoice Due Date Range:</span>
                <TextField
                  label="From Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.fromDateShow}
                  onChange={this.handleDateChange('fromDateShow')}
                  error={this.state.fromDateErr}
                  helperText={this.state.fromDateErrText}
                  style={{ minWidth: '200px' }}
                />
                <TextField
                  label="To Date"
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  value={this.state.toDateShow}
                  onChange={this.handleDateChange('toDateShow')}
                  error={this.state.toDateErr}
                  helperText={this.state.toDateErrText}
                  style={{ minWidth: '200px' }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.submitFilter}
                  disabled={!this.state.fromDateShow || !this.state.toDateShow}
                >
                  Apply Filter
                </Button>
                <Button
                  variant="outlined"
                  onClick={this.clearFilter}
                  disabled={!this.state.fromDateShow && !this.state.toDateShow}
                >
                  Clear Filter
                </Button>
              </div>
            )}
            
          </div>
        )}

        <Table 
          data={
            this.state.currentEntity === 'approved' 
              ? (this.state.showHoldData 
                    ? this.state.holdData 
                    : this.state.filteredData) 
              : this.state.data
          } 
          columns={this.state.columns} 
          updateSelected={this.updateSelected.bind(this)} 
          tablePageChangehandler={this.tablePageChangehandler} 
          pageIndex={this.state.pageIndex}
          handleOk={this.handleOk.bind(this)} 
          selection={this.state.tableState.selection} 
          selectedData={this.state.tableState.selectedData}
          selectAll={this.state.tableState.selectAll}
        />
        {this.state.showDialogBox && (
          <DialogBox
            AlertText="Are you sure you want to delete this request"
            handleClose={this.handleClose.bind(this)}
            handleYes={this.handleYes.bind(this)}
            handleNo={this.handleNo.bind(this)}
          />
        )}
        
        {
          (Boolean(this.state.data.length) && (this.state.currentEntity === 'approved' || this.state.currentEntity === 'approve')) &&
          <div className="zaps-btn-cluster">
            <Button variant="contained" size="large" color="primary" onClick={this.generateCSV.bind(this)}>
              Download CSV
            </Button>
            {token && (token.role === 'Super Central Finance' || token.role === 'root' || token.role === 'Payment Hold Operator') && this.state.currentEntity === 'approved' && this.state.showHoldData && (
              <Button variant="contained" size="large" color="secondary" disabled={this.state.disablePaymentInitBtn}
                onClick={this.handleUnholdButtonClick.bind(this)}>
                Unhold
              </Button>
            )}
            {token && (token.role === 'Super Central Finance' || token.role === 'root') && this.state.currentEntity === 'approved' && !this.state.showHoldData && (
              <Button variant="contained" size="large" color="primary" disabled={this.state.disablePaymentInitBtn}
                onClick={() => { this.handleInitializePayment.bind(this)() }}>
                Initialize Payment
              </Button>
            )}
          </div>
        }
        <PaymentInitAuth
          value={this.state.secretKey} show={this.state.showAuth}
          updateSecreKey={this.updateSecreKey.bind(this)}
          handleCancelPaymentInitAuth={this.handleCancelPaymentInitAuth.bind(this)}
          handlePaymentInitAuth={this.handlePaymentInitAuth.bind(this)}
          generateOtp={this.otpGeneration.bind(this)}
          SecretKeyErrorText={this.state.secretKeyErrorText}
          SecretKeyError={this.state.hasSecreKeyError}
        />
        <Snackbar
          open={this.state.snackOpen}
          message={this.state.snackMessage}
          autoHideDuration={2000}
          onClose={this.handleCloseSnack.bind(this)}
        />
        <Dialog
          open={this.state.blockedPaymentDialogBox}
          onClose={this.handleCloseblockedPaymentDialogBox.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.blockedPaymentDialogBoxText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseblockedPaymentDialogBox.bind(this)} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Payment is intializing"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please wait ...
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <Dialog
          open={this.state.otpDialogbox}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={this.handleOtpNo.bind(this)}
        >
          <DialogTitle id="alert-dialog-title">{"Reset Password"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <TextField
                label='OTP'
                placeholder='Enter OTP'
                value={this.state.otp}
                onChange={this.handleChange.bind(this, 'otp')}
                style={{ width: '250px' }}
                margin='normal'
                error={this.state.otpErr}
                helperText={this.state.otpErrText}
              /><br />
              <TextField
                label='New Password'
                placeholder='Enter new password'
                type='password'
                value={this.state.password}
                onChange={this.handleChange.bind(this, 'password')}
                style={{ width: '250px' }}
                margin='normal'
                error={this.state.passwordErr}
                helperText={this.state.passwordErrText}
              /><br />
              <TextField
                label='Confirm Password'
                placeholder='Enter  password'
                type='password'
                value={this.state.confirm_password}
                onChange={this.handleChange.bind(this, 'confirm_password')}
                style={{ width: '250px' }}
                margin='normal'
                error={this.state.confirm_passwordErr}
                helperText={this.state.confirm_passwordErrText}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleOtpNo.bind(this)} color="primary">
              No
            </Button>
            <Button onClick={this.handleSubmit.bind(this)} color="primary" autoFocus>
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.confirmHoldDialogOpen}
          onClose={this.closeConfirmHoldDialog.bind(this)}
          aria-labelledby="confirm-hold-dialog-title"
          aria-describedby="confirm-hold-dialog-description"
        >
          <DialogTitle id="confirm-hold-dialog-title">
            {this.state.showHoldData ? "Confirm Unhold Payment" : "Confirm Hold Payment"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="confirm-hold-dialog-description">
              {!this.state.showHoldData && (
                <TextField
                  autoFocus
                  margin="dense"
                  label="Hold Reason"
                  type="text"
                  fullWidth
                  value={this.state.holdComment}
                  onChange={(e) => this.setState({ holdComment: e.target.value })}
                  required
                />
              )}
              {this.state.showHoldData && (
                <TextField
                  autoFocus
                  margin="dense"
                  label="Unhold Reason"
                  type="text"
                  fullWidth
                  value={this.state.unholdComment}
                  onChange={(e) => this.setState({ unholdComment: e.target.value })}
                  required
                />
                )}
              Are you sure you want to {this.state.showHoldData ? "unhold" : "hold"} payments with PR ids {this.state.selectedPaymentRequestIds.pr_ids.join(', ')}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeConfirmHoldDialog.bind(this)} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                this.state.showHoldData
                  ? this.confirmUnholdPayment()
                  : this.confirmHoldPayment();
              }}
              color="primary"
              autoFocus
              disabled={
                (this.state.showHoldData && !this.state.unholdComment) || 
                (!this.state.showHoldData && !this.state.holdComment)
              } // Require comment for hold & unhold
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        </div>{/* end zaps-page-wrap */}
      </MuiThemeProvider>
    );
  }
}
export default PaymentProcess



// WEBPACK FOOTER //
// ./src/components/PaymentProcess.js